import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import WorkloadColumn from '../../components/projectmanager/new/Assigned/WorkloadColumn';

class PMWorkloadContainer extends Component {

	state = {
		isLoading: false,
	}

	componentWillMount() {
		this.retrieveAndFilter();
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.retrieveAndFilter();
		}
	}

	retrieveAndFilter() {
		const p = this.props;
		let currentItem = p.reduxData.storedPhases[this.props.reduxData.currentPhase];

		this.setState(function () {
			return {
				isLoading: true
			}
		});

		this.setState(function () {
			return {
				isLoading: false,
				distinctColumns: p.reduxData.storedUsers,
				currentItem: currentItem
			}
		});
	}

	render() {
		const { isLoading, distinctColumns, currentItem } = this.state;
		const moveTask = this.moveTask;
		const pmProps = {
			isLoading,
			moveTask
		}

		return <div className={"PMTaskGroups"}>

			<WorkloadColumn
				key={'_column_unassigned_tasks'}
				columnTitle={null}
				uniqueID={null}
				tasks={this.props.reduxData.storedTasks}
				colIndex={0}
				phaseID={currentItem.uniqueID}
				{...pmProps}
			/>

			{distinctColumns.map((col, i) => (
				<WorkloadColumn
					key={'_column_' + col.uniqueID}
					columnTitle={col.firstName + ' ' + col.lastName.substring(0, 1)}
					uniqueID={col.uniqueID}
					tasks={this.props.reduxData.storedTasks}
					colIndex={i + 1} // IMPORTANT
					phaseID={currentItem.uniqueID}
					{...pmProps}
				/>
			))}

		</div>
	}

	moveTask = (sourceTask, column) => {
		let copy = Object.assign({}, sourceTask);

		if (column === null) {
			console.log('unassigned user');
			copy.assigned = [];
		} else if (copy.assigned.includes(column)) {
			console.log('task already assigned to user');
		} else {
			copy.assigned = [...copy.assigned, column]; // append
			//copy.assigned[0] = column; //overwrite
			this.props.updateTask(copy);
		}
	}
}

function mapStateToProps(state) {
	return {
		reduxData: state.pmData
	}
}

const mapDispatchToProps = dispatch => {
	return {
		openOverlay: (obj) => {
			dispatch(actions.globalState.openOverlay(obj));
		},
		addTaskGroup: (obj) => {
			dispatch(actions.pm.addTaskGroup(obj))
		},
		addTask: (obj) => {
			dispatch(actions.pm.addTask(obj))
		},
		updateTaskGroup: (obj) => {
			dispatch(actions.pm.updateTaskGroup(obj))
		},
		updateTask: (obj) => {
			dispatch(actions.pm.updateTask(obj))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PMWorkloadContainer);


// WEBPACK FOOTER //
// ./src/containers/projectmanager/PMWorkloadContainer.js